import { RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

const configureRoutes = (routes: RoutesService) => () => {
  routes.add([
    {
      path: '/monitoring',
      iconClass: 'fa fa-eye',
      name: '::Menu:Monitoring',
      order: 2,
      parentName: '::Menu:Dashboards',
      requiredPolicy: 'LiveChat.Monitoring',
    },
  ]);
};

export const MONITORING_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];
